import Layout from "../components/Layout/HomeLayout";
import "./NewYearTripsLandingPage.css";
import FaqNewYear from "../components/FaqNewYear";
import SiteReviews from "../components/SiteReviews";
import newyearLandingPhoto from "../images/newyearlandingpagephotoo.png";
import React, { useEffect, useRef, useState } from "react";
import Form from "../components/Contact/Form";
import bannerImg from "../images/newyearlandingpagebannner.png";
import bannerBelow1 from "../images/newyearlandingpagebannnerr2.jpeg";
import bannerBelow2 from "../images/newyearlandingpagebannnerr4.jpeg"; // if you want same or different, adjust path
import newyearLandingCard1 from "../images/newyearlandingcard1.png";
import newyearLandingCard2 from "../images/newyearlandingcard2.png";
import newyearLandingCard3 from "../images/newyearlandingcard3.png";
import newyearLandingCard4 from "../images/newyearlandingcard4.png";
import newyearWhyImage from "../images/newyearwhyimage.png";


const NewYearTripsLandingPage = () => {
  const sliderRef = useRef(null);
const whySliderRef = useRef(null);
  const [showExpertForm, setShowExpertForm] = useState(false); // ✅ control popup form
useEffect(() => {
  const container = sliderRef.current;
  if (!container) return;

  const isMobile = window.innerWidth <= 768;
  if (!isMobile) return; // only mobile auto-slide

  const cardWidth = container.children[0].clientWidth + 16; // including gap

  let scrollPos = 0;

  const interval = setInterval(() => {
    scrollPos += cardWidth;

    // Adjust the scroll position to loop through all cards, including the last one
    if (scrollPos >= container.scrollWidth - cardWidth) {
  scrollPos = 0;
}


    container.scrollTo({
      left: scrollPos,
      behavior: "smooth",
    });
  }, 3000); // Slide every 3 seconds

  return () => clearInterval(interval);
}, []);

// ✅ Auto-slider for WHY HIGH MOUNTAINS images (mobile only)
useEffect(() => {
  const container = whySliderRef.current;
  if (!container) return;

  const isMobile = window.innerWidth <= 768;
  if (!isMobile) return;

  const cardWidth = container.children[0].clientWidth + 16;

  let scrollPos = 0;

  const interval = setInterval(() => {
    scrollPos += cardWidth;

    if (scrollPos >= container.scrollWidth - container.clientWidth) {
      scrollPos = 0;
    }

    container.scrollTo({
      left: scrollPos,
      behavior: "smooth",
    });
  }, 3000);

  return () => clearInterval(interval);
}, []);

  return (
    <Layout>
      <div className="nye-landing-page">
        {/* 🎥 Top Section (Video + Image + Inclusions) */}
       <section className="nye-landing-top">
  {/* Left Section (Video + Image) */}
  <div className="nye-landing-left">
    <div className="nye-landing-video-box">
      <iframe
        src="https://www.youtube.com/embed/A5EPuDvjjTs?autoplay=1&mute=1&loop=1&playlist=A5EPuDvjjTs&controls=0&modestbranding=1&showinfo=0"
        className="nye-landing-video"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        title="New Year Trips Video"
      ></iframe>
    </div>
<div className="newyear-landing-banner">
  <img src={bannerImg} alt="New Year Banner" className="newyear-banner-image" />
</div>

    <div className="nye-landing-image-box">
      <img
        src={newyearLandingPhoto}
        alt="Image Description"
        className="nye-landing-image"
      />
    </div>
  </div>

  {/* Right Section (Inclusions) */}
  <div className="nye-landing-inclusion-box">
    <h2>NEW YEAR TRIP INCLUSIONS</h2>
    <p className="nye-landing-subtext">
      ALL INCLUSIONS AS PER THE TRIP PURCHASED
    </p>
    <ul>
      <li>3 Star –5 Star Stays – hand picked hotels & resorts where every night feels like a vacation.</li>
      <li>Twin Sharing Rooms – because good stories start with great roommates.</li>
      <li>Breakfast & Dinner – fuel up for the chaos, wind down with good food and better company.</li>
      <li>All Transfers Covered – SUVs, Vans, Speedboats... we'll get you there in style.</li>
      <li>Epic New Year’s Party Access – count down under the stars,not the same city lights.</li>
<li>All Permits & Permissions - sorted .You just show up.</li>  
    <li>Island Trips & Adventure Activities – Jet Ski, Snorkeling & more(for Thailand and Bali).</li>
      <li>20 Strangers. One Tribe. You'll leave with new friends and wild stories.</li>
      <li>Moments that last longer than your hangover.</li>
    </ul>
  </div>
</section>

        {/* 📍 Call to Action Section */}
        <section className="nye-cta-section">
{/* <button
  className="nye-landing-cta-btn"
  onClick={() =>
    window.open(
      "https://wa.me/919888823721?text=Hi!%20I%20want%20to%20book%20a%20New%20Year%20Trip%20with%20High%20Mountains",
      "_blank"
    )
  }
>
  BOOK NOW
</button>  */}
 <button 
    className="nye-landing-cta-btn"
    onClick={() => setShowExpertForm(true)} // ✅ opens form
  >
    TALK TO EXPERTS
  </button>
</section>


        {/* 📍 Destination Section */}
<section className="nye-landing-destinations" ref={sliderRef}>
          <div className="nye-landing-card blue">
            <img         src={newyearLandingCard1}
 alt="Koh Samui" />
            <h3>NYE KOH SAMUI</h3>
            <p>SOLD OUT</p>
            <span>
          AT 11:59 YOU’LL WISH YOU WERE HERE - AT 12:00 YOU’LL KNOW WHY. 
              <br />
             TROPICAL NIGHTS, YACHT PARTIES & A COUNTDOWN YOU’LL NEVER FORGET. 
            </span>
          </div>

          <div className="nye-landing-card yellow">
            <img   src={newyearLandingCard2} alt="Bali" />
            <h3>BURNOUT BALI</h3>
            <p>8 SEATS LEFT</p>
            <span>
BURN OUT YOUR STRESS BEFORE THE YEAR ENDS — IN BALI, NOT AT WORK.               <br />
SUNSETS, BEACH CLUBS & CHAOS BEFORE CALENDARS RESET.             </span>
          </div>

          <div className="nye-landing-card green">
            <img   src={newyearLandingCard3}alt="Ladakh" />
            <h3>NYE LADAKH</h3>
            <p>12 SEATS LEFT</p>
            <span>
WHERE FIREWORKS CAN’T REACH - BUT YOUR SOUL CAN.               <br />
 RING IN THE NEW YEAR  SURROUNDED BY SNOW, STARS & SILENCE THAT SPEAKS.            </span>
          </div>

          <div className="nye-landing-card purple">
            <img   src={newyearLandingCard4} alt="Kashmir" />
            <h3>NYE KASHMIR</h3>
            <p>11 SEATS LEFT</p>
            <span>
              TRADE CONFETTI FOR
 SNOWFLAKES.
 <br/>
WELCOME 2026 IN THE VALLEY OF DREAMS — SERENE, STUNNING, UNFORGETTABLE.
            </span>
          </div>
        </section>
        {/* 📣 Awareness / WhatsApp Section */}
<section className="nye-whatsapp-section">
  <h2>Are You Spending Every New Year Doing the Same Thing?</h2>
  <ul className="nye-whatsapp-points">
    <li>❌ Same city, same faces, same rooftop party.</li>
    <li>❌ Watching others live your dream life on Instagram.</li>
    <li>❌ Promising yourself, “Next year I’ll travel” — every year.</li>
  </ul>

  <p className="nye-whatsapp-text">
    If this feels like you, it’s time to break the loop.
  </p>

  <p className="nye-whatsapp-subtext">
    Start your year where stories begin — on a High Mountains New Year Trip 🚀
    <br />
    <em>Limited Seats. Unlimited Vibes.</em>
  </p>

  <a
    href="https://wa.me/919888823721?text=Hi!%20I%20want%20details%20for%20the%20New%20Year%20Trips"
    target="_blank"
    rel="noopener noreferrer"
    className="nye-whatsapp-btn"
  >
    WHATSAPP US NYE FOR DETAILS
    <img src="/images/whatsapp-icon.png" alt="WhatsApp" />
  </a>

  <p className="nye-whatsapp-click">Click to start a conversation.</p>
</section>
{/* 🌍 Why Travel With High Mountains Section */}
<section className="nye-why-section">
  <h2>
    Why Travel with <span className="highlight">High Mountains</span>
  </h2>

  <div className="nye-why-content">
    {/* Left: Points */}
    <ul className="nye-why-points">
      <li><strong>No Middleman</strong> – We plan the trips ourselves.</li>
      <li><strong>Real Fun</strong> – Not boring tours, only happy memories.</li>
      <li><strong>Best Stays & Routes</strong> – Nice rooms and pretty views.</li>
      <li><strong>Young Team</strong> – Made by people who love to travel.</li>
      <li><strong>All Planned</strong> – You just come and enjoy.</li>
      <li><strong>Your Choice</strong> – Go alone or with friends.</li>
      <li><strong>Fun Mix</strong> – Adventure, culture, and chill time.</li>
      <li><strong>Always There</strong> – Our team helps you anytime.</li>
      <li><strong>For Everyone</strong> – Solo, couple, or group – all welcome.</li>
      <li><strong>Movie Moments</strong> – Trips that look and feel amazing.</li>
      <li><strong>We’re Travelers Too</strong> – We travel just like you do.</li>
    </ul>

    {/* Right: Image */}
   <div className="nye-why-image-box">
  <img
    src={newyearWhyImage}
    alt="Why Travel with High Mountains"
    className="nye-why-image"
  />
</div>

  </div>
</section>


      </div>
      {/* 🌟 Traveller Reviews Section */}
<div className="no-gradient">
  <SiteReviews
  limit={3}
  showButton={true}
  hideHeading={false}
  variant="grid"
  customHeading={
    <>
      <h2 className="review-heading">
        <span className="green-text">10,000+</span> Travelers. One Tribe.
      </h2>
      <p className="review-subtext">
        From Ladakh to Bali – real people, real stories, one vibe.
      </p>
    </>
  }
/>

{/* 🖼️ Two Banners Below Reviews */}
{/* 🖼️ Full-width Banners Below Reviews */}
<section className="nye-fullwidth-banners">
  <img
    src={require("../images/newyearlandingpagebannnerr4.jpeg")}
    alt="New Year Trips Banner 1"
    className="nye-fullwidth-banner"
  />
  <img
    src={require("../images/newyearlandingpagebannnerr2.jpeg")}
    alt="New Year Trips Banner 2"
    className="nye-fullwidth-banner"
  />
</section>

<FaqNewYear />

</div>

      {/* ✅ Expert Form Popup */}
{showExpertForm && (
  <div className="expert-form-overlay">
    <div className="expert-form-popup">
      {/* ✖️ Close Button */}
      <span className="newyeartrips-landing-close-btn" onClick={() => setShowExpertForm(false)}>
        &times;
      </span>

      {/* ✅ Same form used in Ads pages */}
      <Form setExpertForm={setShowExpertForm} />
    </div>
  </div>
)}

    </Layout>
  );
};

export default NewYearTripsLandingPage;
